// Composable for simple localStorage helpers.

const useLocalStorage = storageKey => {
  const getItem = () => {
    try {
      return window.localStorage.getItem(storageKey) || null;
    } catch (e) {
      // Ignore storage errors
      return null;
    }
  };

  const setItem = value => {
    try {
      if (value === undefined || value === null) {
        window.localStorage.removeItem(storageKey);
      } else {
        window.localStorage.setItem(storageKey, value);
      }
    } catch (e) {
      // Ignore storage errors
    }
  };

  const removeItem = () => {
    try {
      window.localStorage.removeItem(storageKey);
    } catch (e) {
      // Ignore storage errors
    }
  };

  return {
    getItem,
    setItem,
    removeItem,
  };
};

export default useLocalStorage;

